import { render } from "./MatchInfoSelection.vue?vue&type=template&id=8bb2b64a"
import script from "./MatchInfoSelection.vue?vue&type=script&lang=js"
export * from "./MatchInfoSelection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__